import {
    fetchBasicJsonPost,
    fetchBasicUrlPost,
    fetchBasicJsonPostJson,
    fetchBasicUrlPostJson
} from '@/script/common';

export default {
    getForms: (page, itemsPerPage, filter, signal) => {
        let parameters = {
            page: page,
            pageSize: itemsPerPage,
            Code: filter.Code && !isNaN(+filter.Code) && +filter.Code ? +filter.Code : null,
            Variant: filter.Variant || null,
            DisplayName: filter.DisplayName || null,
            FormName: filter.FormName || null
        };
        return fetchBasicJsonPostJson('/ElForm/GetForms', {
            data: parameters
        },
        {
            useBlock: !signal
        });
    },
    addForm: formObj =>
        fetchBasicJsonPost('/ElForm/AddForm', { data: formObj }),
    editForm: formObj =>
        fetchBasicJsonPost('/ElForm/EditForm', { data: formObj }),
    deleteForm: id =>
        fetchBasicUrlPost('/ElForm/DeleteForm', { data: { code: id } }),

    addParam: paramObj =>
        fetchBasicJsonPost('/ElForm/AddParam', { data: paramObj }),
    editParam: paramObj =>
        fetchBasicJsonPost('/ElForm/EdiParam', { data: paramObj }),
    deleteParam: id =>
        fetchBasicUrlPost('/ElForm/DeleteParam', { data: { id: id } }),
    getParameters: formId =>
        fetchBasicUrlPostJson('/ElForm/GetFormParams', {
            data: { code: formId }
        }),
    getMohCaseResearchPdfFiles: (historyCode, diagnosisNumber, researchCode) =>
        fetchBasicJsonPostJson('/ElForm/GetMohCaseResearchPdfFiles', {
            data: { historyCode, diagnosisNumber, researchCode }
        }),
    GenerateForm100Pdf: (historyCode, diagnosisNumber, researchCode) =>
        fetchBasicUrlPost('/ElForm/GenerateForm100Pdf', {
            data: { historyCode, diagnosisNumber, researchCode }
        }),
    GenerateOperationProtocolPdf: (historyCode, diagnosisNumber, researchCode) =>
        fetchBasicUrlPost('/ElForm/GenerateOperationProtocolPdf', {
            data: { historyCode, diagnosisNumber, researchCode }
        }),
    GenerateCoronarographyPdf: (historyCode, diagnosisNumber, researchCode) =>
        fetchBasicUrlPost('/ElForm/GenerateCoronarographyPdf', {
            data: { historyCode, diagnosisNumber, researchCode }
        }),
    GenerateXRayPdf: (historyCode, diagnosisNumber, researchCode) =>
        fetchBasicUrlPost('/ElForm/GenerateXRayPdf', {
            data: { historyCode, diagnosisNumber, researchCode }
        }),
    GenerateMRTPdf: (historyCode, diagnosisNumber, researchCode) =>
        fetchBasicUrlPost('/ElForm/GenerateMRTPdf', {
            data: { historyCode, diagnosisNumber, researchCode }
        }),
    GenerateCTPdf: (historyCode, diagnosisNumber, researchCode) =>
        fetchBasicUrlPost('/ElForm/GenerateCTPdf', {
            data: { historyCode, diagnosisNumber, researchCode }
        }),
    GenerateHistomorphologyPdf: (historyCode, diagnosisNumber, researchCode) =>
        fetchBasicUrlPost('/ElForm/GenerateHistomorphologyPdf', {
            data: { historyCode, diagnosisNumber, researchCode }
        }),
    GenerateOtherPdf: (historyCode, diagnosisNumber, researchCode) =>
        fetchBasicUrlPost('/ElForm/GenerateOtherPdf', {
            data: { historyCode, diagnosisNumber, researchCode }
        }),
};
